function publicUrl(path) {
  const base = window.__TEAMILY_PUBLIC_BASE__;
  if (typeof base === "string" && base.length > 0) {
    return base + encodeURIComponent(path);
  }
  return `${window.location.origin}${path}`;
}
export {
  publicUrl
};
